// Split VERBATIM from utils/datetime-comprehensive.js (ESM barrel split).
import { DateTime } from 'luxon';
import { BUSINESS_TIMEZONE } from './dateTimeCore';

export function createBusinessTime(obj, date) {
  const chicagoTime = DateTime.fromObject(
    { ...obj, year: date.split('-')[0], month: date.split('-')[1], day: date.split('-')[2] },
    { zone: BUSINESS_TIMEZONE }
  );
  
  if (!chicagoTime.isValid) {
    throw new Error(`Invalid business time: ${chicagoTime.invalidReason} - ${chicagoTime.invalidExplanation}`);
  }
  
  return chicagoTime.toUTC();
}

/**
 * Handle DST edge cases
 * @param {DateTime} dt - DateTime that might be in DST transition
 * @param {string} policy - 'forward' for spring, 'backward' for fall
 * @returns {DateTime} - Adjusted DateTime
 */

export function handleDSTEdge(dt, policy = 'forward') {
  if (!dt.isValid) {
    if (dt.invalidReason === 'unsupported zone') {
      // Handle nonexistent time (spring forward)
      if (policy === 'forward') {
        console.warn(`DST edge case: Nonexistent time ${dt.toISO()}, shifting forward`);
        return dt.plus({ minutes: 1 });
      }
    }
    // Handle ambiguous time (fall back)
    if (policy === 'backward') {
      console.warn(`DST edge case: Ambiguous time ${dt.toISO()}, choosing earlier`);
      return dt.minus({ hours: 1 });
    }
  }
  
  return dt;
}

/**
 * Get timezone info for display
 * @param {DateTime} dt - DateTime object
 * @returns {Object} - Timezone information
 */

export function getTimezoneInfo(dt) {
  const chicago = dt.setZone(BUSINESS_TIMEZONE);
  return {
    offset: chicago.offsetNameShort,
    zone: chicago.zoneName,
    utc: dt.toUTC().toISO(),
    chicago: chicago.toISO(),
    offsetMinutes: chicago.offset
  };
}

/**
 * Get time remaining for a due date
 * @param {string} utcTimestamp - UTC timestamp from database
 * @returns {string} - Human-readable time remaining
 */

export function createChicagoDateTime(dateStr, timeStr) {
  if (!dateStr || !timeStr) return null;
  
  try {
    const isoString = `${dateStr}T${timeStr}:00`;
    const dt = DateTime.fromISO(isoString, { zone: BUSINESS_TIMEZONE });
    
    if (!dt.isValid) {
      throw new Error(`Invalid date/time: ${dt.invalidReason} - ${dt.invalidExplanation}`);
    }
    
    return dt;
  } catch (error) {
    console.error('Error creating Chicago DateTime:', error);
    return null;
  }
}


/**
 * Get Chicago timezone abbreviation
 * @returns {string} Timezone abbreviation (CST/CDT)
 */
